import { render } from "./AlertRingraziamento.vue?vue&type=template&id=24ce77e6"
import script from "./AlertRingraziamento.vue?vue&type=script&lang=js"
export * from "./AlertRingraziamento.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__